export const TOKEN_KEY = '__ppToken';
export const USER_KEY = '__ppUsername';
export const APP_ID = 'RgkPAszd';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const SHIFT_SEND_REPORT = 'SHIFT_SEND_REPORT';
export const API_URL = process.env.REACT_APP_API_URL;